// extracted by mini-css-extract-plugin
export default {"spinnerWrapper":"LoadingIndicator_spinnerWrapper__24dFk","spinner":"LoadingIndicator_spinner__3_Wz7"};